import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";
import { DriverActionTypes, DriverActions } from "../../../actionTypes/master/driverActionType";
import {
  createDriverApi,
  editDriverDataByIdApi,
  getDriverDataByIdApi,
  getDriverListApi,
} from "../../requests/master/driverRequests";
import { getDriverList, setDriverDataById, setDriverList, setDriverListPageCount } from "../../../actions/master/driverAction";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";


function* createDriverHandler(action: DriverActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createDriverApi, action.payload);

    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getDriverListHandler(action: DriverActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");
    const { data } = yield call(getDriverListApi, action.payload);
    if (data.status) {
      yield put(setDriverList(data?.data?.rows));
      yield put(setDriverListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getDriverDataByIdHandler(action: DriverActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getDriverDataByIdApi, action.payload);
    if (data.status) {
      yield put(setDriverDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editDriverDataByIdHandler(action: DriverActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editDriverDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getDriverList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// user sagas
export default function* driverSaga() {
  yield takeLatest(DriverActions.CREATE_DRIVER, createDriverHandler);
  yield takeLatest(DriverActions.GET_DRIVER_LIST, getDriverListHandler);
  yield takeLatest(DriverActions.GET_DRIVER_DATA_BY_ID, getDriverDataByIdHandler);
  yield takeLatest(DriverActions.EDIT_DRIVER_DATA_BY_ID, editDriverDataByIdHandler);
}
